import { categoriesNlToEn } from "@config/urls"
import { ArticleQuery } from "@generated"
import { getDynamicSeoDescription } from "@lib/get-dynamic-seo-description"
import { getGraphQLClient } from "@lib/graphql-client"
import { ErrorPage } from "@screens/error"
import Product from "@screens/product"
import { NextPage } from "next"

type Props = {
  pid?: string
  uid?: string
  statusCode?: number
  article?: ArticleQuery["choicesArticle"]
  description?: string | null
}

const { sdk } = getGraphQLClient()

const ProductDetailPage: NextPage<Props> = ({
  pid,
  uid,
  statusCode,
  article,
  description
}) => {
  if (statusCode) {
    return <ErrorPage statusCode={statusCode} />
  }
  if (!article || !uid || !pid) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <Product
      uid={uid}
      pid={pid}
      article={article}
      articlesId={[article.id]}
      productType="article"
      lang={"nl-nl"}
      description={description}
    />
  )
}

ProductDetailPage.getInitialProps = async ({ query, lang }) => {
  const uid =
    lang === "nl"
      ? categoriesNlToEn[query["uid"] as string]
      : (query.uid as string)
  const pid = query["pid"] as string
  const id = pid.split("-").pop() as string

  try {
    const result = await sdk.Article({
      id
    })

    const description = await getDynamicSeoDescription({
      item: result.choicesArticle,
      urlSlug: uid,
      lang
    })

    if (!result || !result.choicesArticle) {
      return { statusCode: 404 }
    }

    return {
      article: result.choicesArticle,
      uid,
      pid: id,
      description
    }
  } catch (error) {
    return {
      statusCode: 500
    }
  }
}

export default ProductDetailPage
